const duplicateTranslationKey = (key: string): string => key;

export const translationUploadData_sv_part4 = {
  errorFetchingOrganizations: "Fel vid hämtning av organisationer",
  createFolder: "Skapa mapp",
  createNewFolder: "Skapa ny mapp",
  folderName: "Mappnamn",
  enterFolderName: "Ange mappnamn",
  parentFolder: "Överordnad mapp",
  selectParentFolder: "Välj överordnad mapp",
  rootNoFolder: "Rot (ingen mapp)",
  uploadToFolder: "Ladda upp till mapp",
  selectFolder: "Välj mapp",
  folderNameRequired: "Mappnamn krävs",
  folderCreatedSuccessfully: "Mapp skapad",
  errorCreatingFolder: "Fel vid skapande av mapp",
  creatingFolder: "Skapar...",
  uploadToThisFolder: "Ladda upp till den här mappen",
  entryMovedToFolder: "Post flyttad till mapp",
  entryMovedToRoot: "Post flyttad till rot",
  errorMovingEntryToFolder: "Det gick inte att flytta posten till mappen",
  dragToMove: "Dra för att flytta",
  noIndexesAvailable: "Inga kunskapsbaser tillgängliga",
  retry: "Försök igen",
  numberOfChunks: "Antal delar",
  renameFolder: "Byt namn på mapp",
  renameFolderButton: "Byt namn",
  renamingFolder: "Byter namn...",
  folderRenamedSuccessfully: "Mapp omdöpt",
  errorRenamingFolder: "Det gick inte att byta namn på mappen",
  changesSavedSuccessfully: "Ändringar sparade",
  allInformationChunksLoaded: "Alla informationsdelar inlästa",
  smartChunking: "Smart uppdelning",
  smartChunkingTooltip:
    "Delar automatiskt upp PDF:en i meningsfulla delar baserat på rubriker, stycken och innehållsstruktur. Rekommenderas för bättre söknoggrannhet.",
  pdfChunkingResults: "PDF-uppdelningsresultat",
  textChunkingResults: "Textstyckningsresultat",
  totalChunks: "Antal delar",
  avgSize: "Genomsnittlig storlek",
  range: "Intervall",
  chars: "tecken",
  chunkUploadNote: "Varje del laddas upp som en separat, sökbar post",
  uploadPdfLabel: "Ladda upp PDF (valfritt)",
  uploadPdfButton: "Ladda upp PDF",
  extractingText: "Extraherar text...",
  uploadPdfDescription:
    "Ladda upp en PDF-fil för att automatiskt extrahera och fylla i texten nedan",
  pdfLoaded: "Inläst",
  verifyFileType: "Filtypen är inte giltig. Välj en PDF-fil.",
  [duplicateTranslationKey("immediateUpload")]: "Ladda upp direkt",
  [duplicateTranslationKey("scheduleUpload")]: "Schemalägg uppladdning",
  itemCreatedOn: "Skapad {date}",
  itemEditedOn: "Redigerad {date}",
  viewHistory: "Visa historik",
};
